export const lerPlanilha = async (planilha) => {
  const planilhaText = await planilha.text()
  const arrayDados = planilhaText.split(/\r?\n/).map(item => item.split(','))
  let dadosTratados = []

  for (const [indexDado, dado] of arrayDados.entries()) {
    if (indexDado > 0 && indexDado < arrayDados.length - 1) {
      let objeto = {}

      for (const [indexLinha, linha] of dado.entries()) {
        const nomeAtributo = arrayDados[0][indexLinha]
        objeto = { ...objeto, [nomeAtributo]: linha }
      }
      dadosTratados.push(objeto)

    }
  }

  return dadosTratados
}